import { get, put, post, del } from '@/api/request'

// 分页查询所有动态
export function getCirclePostPage(params) {
  return get('/circle/manage/list', params)
}

// 获取动态详情
export function getCirclePostDetail(id) {
  return get(`/circle/manage/${id}`)
}

// 平台发布动态
export function publishCirclePost(data) {
  return post('/circle/manage/publish', data)
}

// 删除动态
export function deleteCirclePost(id) {
  return del(`/circle/manage/${id}`)
}

// 重新上架动态
export function onlineCirclePost(id) {
  return put(`/circle/manage/${id}/online`)
}

// 设置/取消置顶
export function updateCirclePostTop(id, data) {
  return put(`/circle/manage/${id}/top`, data)
}

// 待审核动态列表
export function getPendingAuditList(params) {
  return get('/circle/audit/pending', params)
}

// 审核通过
export function approveCirclePost(id) {
  return put(`/circle/audit/${id}/approve`)
}

// 审核拒绝
export function rejectCirclePost(id, data) {
  return put(`/circle/audit/${id}/reject`, data)
}
